var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisenamos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "dise\\xF1amos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_47",
    "data-name": "Rect\\xE1ngulo 47",
    width: 18.37,
    height: 18.316,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_23",
    "data-name": "Rect\\xE1ngulo 23",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_61",
    "data-name": "Grupo 61",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_60",
    "data-name": "Grupo 60",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_38",
    "data-name": "Trazado 38",
    d: "M17.637,16.816H.734a.75.75,0,0,0,0,1.5h16.9a.75.75,0,0,0,0-1.5",
    fill: "#1c1c1c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_39",
    "data-name": "Trazado 39",
    d: "M3.945,15.319a.265.265,0,0,0,.063-.008l2.949-.76.006,0a2.832,2.832,0,0,0,1.228-.713l9.54-9.54a2,2,0,0,0,0-2.825L16.792.542a2.112,2.112,0,0,0-2.824,0l-9.541,9.53a2.73,2.73,0,0,0-.7,1.232l-.74,2.76a.982.982,0,0,0,.255.961,1.017,1.017,0,0,0,.707.294m1-2.8.221-.827a1.28,1.28,0,0,1,.323-.559l.2-.2,1.637,1.637-.2.193-.007.007a1.232,1.232,0,0,1-.553.321l-.831.222ZM6.759,9.879,13.135,3.5l1.636,1.637L8.394,11.516ZM14.2,2.438l.834-.842a.51.51,0,0,1,.706,0l.931.941a.5.5,0,0,1,0,.708l-.831.832Z",
    transform: "translate(0 2)",
    fill: "#1c1c1c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisenamos);
export default __webpack_public_path__ + "static/media/disenamos.7c6370ee6764bbd7b67f89919902cdaf.svg";
export { ForwardRef as ReactComponent };